import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Spinner from './components/common/Spinner';

// Platform
import PlatformHome    from './pages/Platform/Home';
// Auth
import SchoolLanding   from './pages/Auth/SchoolLanding';
import Login           from './pages/Auth/Login';
import ForgotPassword  from './pages/Auth/ForgotPassword';
import ResetPassword   from './pages/Auth/ResetPassword';
// Super Admin
import SuperAdminApp   from './pages/SuperAdmin/SuperAdminApp';
// Admin
import AdminApp        from './pages/Admin/AdminApp';
// Teacher
import TeacherApp      from './pages/Teacher/TeacherApp';
// Learner
import LearnerApp      from './pages/Learner/LearnerApp';
// Parent
import ParentApp       from './pages/Parent/ParentApp';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role) && user.type !== 'platform') {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  const { loading } = useAuth();
  if (loading) return <Spinner />;

  return (
    <BrowserRouter>
      <Routes>
        {/* Platform */}
        <Route path="/"                 element={<PlatformHome />} />
        {/* Parent login — platform level, no slug */}
        <Route path="/parent/login"              element={<Login />} />
        <Route path="/parent/forgot-password"    element={<ForgotPassword />} />
        <Route path="/parent/reset-password"     element={<ResetPassword />} />
        <Route path="/super-admin/login"          element={<Login />} />
        <Route path="/super-admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/super-admin/reset-password"  element={<ResetPassword />} />
        {/* School public page */}
        <Route path="/school/:slug"                element={<SchoolLanding />} />
        <Route path="/school/:slug/login"          element={<Login />} />
        <Route path="/school/:slug/forgot-password" element={<ForgotPassword />} />
        <Route path="/school/:slug/reset-password"  element={<ResetPassword />} />
        {/* Super Admin */}
        <Route path="/super-admin/*"    element={
          <ProtectedRoute roles={['super_admin']}>
            <SuperAdminApp />
          </ProtectedRoute>
        } />
        {/* Admin */}
        <Route path="/admin/*"          element={
          <ProtectedRoute roles={['admin']}>
            <AdminApp />
          </ProtectedRoute>
        } />
        {/* Teacher */}
        <Route path="/teacher/*"        element={
          <ProtectedRoute roles={['teacher']}>
            <TeacherApp />
          </ProtectedRoute>
        } />
        {/* Learner */}
        <Route path="/learner/*"        element={
          <ProtectedRoute roles={['learner']}>
            <LearnerApp />
          </ProtectedRoute>
        } />
        {/* Parent */}
        <Route path="/parent/*"         element={
          <ProtectedRoute roles={['parent']}>
            <ParentApp />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
